<div *ngIf="previewData">
  <div *ngIf="isCsvData && csvHeaders.length > 0" class="table-responsive">
    <h5>CSV Preview</h5>
    <table class="table table-striped table-bordered">
      <thead>
        <tr>
          <th *ngFor="let header of csvHeaders">{{ header }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of csvRows">
          <td *ngFor="let header of csvHeaders">{{ row[header] }}</td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Changed to render ImageBitmaps on canvas -->
  <div *ngIf="!isCsvData && imageBitmapsToRender.length > 0">
    <h5>Image Preview</h5>
    <div *ngFor="let bitmap of imageBitmapsToRender; let i = index" class="image-preview-container">
      <canvas #previewCanvas class="preview-canvas" style="border: 1px solid #ccc; margin-bottom: 10px;"></canvas>
      <!-- Width and height are set in drawImages method to 768x768 -->
    </div>
  </div>

  <!-- Updated empty state check for images -->
  <div *ngIf="showEmptyImageState">
     <p>No images to display for preview, or image data is empty.</p>
  </div>
  <!-- More specific empty state for CSV -->
  <div *ngIf="isCsvData && csvHeaders.length === 0 && csvRows.length === 0 && previewData && !imageBitmapsToRender.length">
     <p>CSV file seems to be empty or has no headers.</p>
  </div>

</div>
<div *ngIf="!previewData">
  <p>No preview data loaded.</p>
</div>
